import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SharedService } from './sharedService';

const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };

@Injectable()
export class PortalNewsletterService {
    constructor(private http: HttpClient, private sharedService: SharedService) {}

    listSubscribers(): Observable<any[]> {
        return this.http.get<any[]>(this.sharedService.apiUrl('api/portal-newsletter/subscribers'));
    }

    broadcast(subject: string, body: string): Observable<any> {
        return this.http.post<any>(
            this.sharedService.apiUrl('api/portal-newsletter/broadcast'),
            { subject, body },
            httpOptions,
        );
    }

    broadcastHistory(): Observable<any[]> {
        return this.http.get<any[]>(this.sharedService.apiUrl('api/portal-newsletter/broadcasts'));
    }

    deleteSubscriber(id: string): Observable<any> {
        return this.http.post<any>(
            this.sharedService.apiUrl('api/portal-newsletter/subscribers/delete'),
            { id },
            httpOptions,
        );
    }
}
